/* Mint-Tasks · tab Tôi đang thay + Team (board isDelTab / isTeamTab) */
.absent { height: 42px; padding: 0 14px; border: 0; border-radius: 12px; background: var(--err-bg); color: var(--err); font: inherit; font-weight: var(--fw-label); cursor: pointer; white-space: nowrap; display: inline-flex; align-items: center; justify-content: center; gap: 6px; }
.cards { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 14px; }
.card { padding: 18px 20px; border-radius: 16px; background: var(--card); box-shadow: var(--sh); cursor: pointer; display: flex; flex-direction: column; gap: 10px; }
.card[data-sel='true'] { box-shadow: 0 0 0 2px var(--pri); }
.cardHd { display: flex; align-items: center; gap: 10px; }
.cardHd > div { flex-grow: 1; }
.cardHd b { font-weight: var(--fw-title); }
.cardHd > div > div { font-size: 12px; color: var(--lb); }
.av { width: 34px; height: 34px; border-radius: 50%; background: var(--sub); display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: var(--fw-title); }
.live { padding: 2px 9px; border-radius: 999px; font-size: 12px; font-weight: var(--fw-label); background: var(--ok-bg); color: var(--ok); }
.card dl { margin: 0; display: grid; grid-template-columns: 96px 1fr; gap: 6px 12px; }
.card dt { color: var(--lb); }
.card dd { margin: 0; }
.cardFt { display: flex; gap: 16px; padding-top: 10px; border-top: 1px solid var(--line); }
.secHd { display: flex; align-items: center; height: 44px; padding: 0 18px; border-bottom: 1px solid var(--line); }
.secHd b { font-weight: var(--fw-title); }
.forK { width: 170px; font-size: 12px; color: var(--tx2); }
.two { display: grid; grid-template-columns: minmax(0, 1.7fr) minmax(0, 1fr); gap: 14px; }
.panel { padding: 14px 18px; border-radius: 16px; background: var(--card); box-shadow: var(--sh); }
.panel > b, .panelHd b { font-weight: var(--fw-title); }
.panelHd { display: flex; justify-content: space-between; align-items: baseline; margin-bottom: 6px; }
.legend { display: inline-flex; align-items: center; gap: 4px; font-size: 12px; color: var(--lb); }
.legend i { width: 10px; height: 8px; border-radius: 2px; margin-left: 8px; }
.barRow { display: grid; grid-template-columns: 76px minmax(0, 1fr) 96px; align-items: center; gap: 10px; height: 30px; }
.barRow > span:first-child { font-weight: var(--fw-label); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.barRow > span:last-child { font-size: 12px; color: var(--lb); }
.barRow b { font-weight: var(--fw-label); color: var(--tx); }
.barRow b.err { color: var(--err); }
.track { height: 10px; }
.track > div { display: flex; gap: 2px; height: 100%; }
.track > div > div { border-radius: 3px; }
.gauge { display: flex; align-items: center; gap: 14px; margin-top: 10px; }
.gauge svg { flex-shrink: 0; }
.gauge > div { display: flex; flex-direction: column; gap: 8px; }
.gauge span { display: block; font-size: 12px; color: var(--lb); }
.gauge b { font-weight: var(--fw-label); }
.tbl { border-radius: 16px; background: var(--card); box-shadow: var(--sh); overflow: clip; }
.tbl table { width: 100%; table-layout: fixed; border-collapse: collapse; white-space: nowrap; }
.tbl th { height: 42px; padding: 0 14px; font-size: 12px; font-weight: 500; color: var(--lb); text-align: left; border-bottom: 1px solid var(--line); }
.tbl th:first-child, .tbl td:first-child { padding-left: 18px; }
.tbl th:last-child, .tbl td:last-child { padding-right: 18px; }
.tbl tr { border-bottom: 1px solid var(--line); }
.tbl td { height: 56px; padding: 0 14px; overflow: hidden; text-overflow: ellipsis; }
.tbl td b { font-weight: var(--fw-label); }
.tbl td > div:not(.ont) { font-size: 12px; color: var(--lb); overflow: hidden; text-overflow: ellipsis; }
.r { text-align: right !important; }
.hot { color: var(--warn); font-weight: var(--fw-title); }
.ont { display: flex; align-items: center; gap: 10px; }
.ont > div { flex-grow: 1; height: 8px; border-radius: 4px; background: var(--line); overflow: hidden; }
.ont > div > div { height: 100%; border-radius: 4px; }
.ont b { width: 40px; text-align: right; }
.unlock { height: 30px; padding: 0 10px; border: 0; border-radius: 8px; background: var(--err-bg); color: var(--err); font: inherit; font-size: 12px; font-weight: var(--fw-label); cursor: pointer; display: inline-flex; align-items: center; gap: 6px; white-space: nowrap; }
.unlock[data-on='true'] { background: var(--ok-bg); color: var(--ok); }
.free { font-size: 12px; color: var(--lb); }
.esc { display: flex; align-items: center; gap: 12px; min-height: 48px; border-top: 1px solid var(--line); }
.esc[data-first='true'] { border-top: 0; }
.esc > div { flex-grow: 1; min-width: 0; }
.esc > div > div:last-child { font-size: 12px; color: var(--lb); }
.esc > div > div:first-child { font-weight: var(--fw-label); }
.late { color: var(--err); font-weight: var(--fw-label); }
